import { useEffect, useState } from "react";
import { collection, addDoc, Timestamp, where, query, onSnapshot } from "firebase/firestore";
import { db } from "@/firebaseConfig.js";
import { useCurrentUserFromFirestore } from "@/utils/useCurrentUserFromFirestore.js";

export const useTopUp = () => {
  const { firestoreUser } = useCurrentUserFromFirestore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [pendingSum, setPendingSum] = useState(0);

  useEffect(() => {
    if (!firestoreUser) return;

    const transactionsRef = collection(db, "transactions");
    const q = query(
      transactionsRef,
      where("userId", "==", firestoreUser.uid),
      where("status", "==", "pending")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      let sum = 0;
      snapshot.forEach((doc) => {
        sum += doc.data().amount;
      });
      setPendingSum(sum);
    });

    return () => unsubscribe();
  }, [firestoreUser]);

  const handleWithdrawal = async ({ amount, method }) => {
    try {
      if (amount <= 0 || amount > firestoreUser.balance || !method) {
        setError(true);
        return;
      }

      const transactionsRef = collection(db, "transactions");
      await addDoc(transactionsRef, {
        userId: firestoreUser.uid,
        amount,
        method,
        status: "pending",
        createdAt: Timestamp.now(),
        userEmail: firestoreUser.email,
      });

      setSuccess(true);
      setError(false);
    } catch (err) {
      setError(true);
      throw err;
    }
  };

  return {
    firestoreUser,
    pendingSum,
    isModalOpen,
    openModal: () => setIsModalOpen(true),
    closeModal: () => setIsModalOpen(false),
    handleWithdrawal,
    success,
    error,
    clearSuccess: () => setSuccess(false),
    clearError: () => setError(false),
  };
};
